import React from "react";

interface DragDropOverlayProps {
  isDragging: boolean;
  isFileUploadDisabled: boolean;
  isLandingPage?: boolean;
}

export const DragDropOverlay: React.FC<DragDropOverlayProps> = ({
  isDragging,
  isFileUploadDisabled,
  isLandingPage: _isLandingPage = false,
}) => {
  if (!isDragging) return null;

  return (
    <div className="fixed inset-0 z-50 pointer-events-none">
      {/* Background overlay for the entire container */}
      <div
        className="absolute inset-0 bg-gray-400/20 dark:bg-gray-600/20"
        style={{ marginLeft: "270px" }}
      ></div>

      <div className="relative w-full h-full">
        <svg className="w-full h-full">
          {/* Main marching ants border - excluding sidebar */}
          <rect
            x="290"
            y="20"
            width="calc(100% - 310px)"
            height="calc(100% - 40px)"
            rx="16"
            ry="16"
            fill="none"
            stroke={isFileUploadDisabled ? "#ef4444" : "#497b8b"}
            strokeWidth="4"
            strokeDasharray="12, 8"
            strokeDashoffset="0"
            style={{
              animation: "dash 1s linear infinite",
            }}
          />
        </svg>
      </div>
    </div>
  );
};
